import { getFiGrowthBook } from './growthbook';

/**
 * Moved here verbatim from NanoBanner.tsx, which re-exports it: the cookie util consumes this
 * flag check, and importing it through the component dragged the animation stack into every
 * dependent (and broke jest for their tests).
 */
export function getNanoDeviceOfferEnabled() {
  const elevatedNanoOffer = getFiGrowthBook().getFeatureValue<{ mini: boolean; s3p: boolean }>(
    'nano-device-offer-enabled',
    { mini: false, s3p: false },
  );

  if (window.location.pathname.includes('smart-collar') && !elevatedNanoOffer.s3p) {
    return false;
  }

  if (window.location.pathname.includes('mini') && !elevatedNanoOffer.mini) {
    return false;
  }

  return true;
}
